import { colors } from '@globals/themes/defaultTheme'
import { Award } from '@kudos/http-client'
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined'
import Stack from '@mui/material/Stack'
import { shuffle } from 'lodash/fp'
import KudosTvCard from '../KudosTvCard'
import ScrollingContent from '../ScrollingContent'
import SenderAndReceivers from '../sendersAndRecievers/SenderAndReceivers'
import TvAwardBadge from './TvAwardBadge'

type TvAwardProps = {
  award: Award
}

const TvAward: React.FC<TvAwardProps> = ({ award }) => {
  const shuffledArray = shuffle(award.sendTo)

  return (
    <KudosTvCard
      primaryColor={colors.irisPrimary}
      icon={<EmojiEventsOutlinedIcon />}
      postedDate={award.createdAt}
      postContent={
        <Stack direction="row" justifyContent="space-between" useFlexGap gap={10} pr={2}>
          <Stack direction="row">
            <SenderAndReceivers
              sender={award.sender}
              receivers={shuffledArray}
              textColor={colors.grayDark}
            />
          </Stack>
          <Stack flexGrow={1} useFlexGap gap={4}>
            <TvAwardBadge name={award.name} badgeUrls={award.badgeUrls} />
            <ScrollingContent
              htmlContent={award.message}
              contentSx={{ color: colors.grayDark, fontSize: '2.5rem' }}
              maxHeight="60vh"
            />
          </Stack>
        </Stack>
      }
    />
  )
}

export default TvAward
